<div class="content">
  <!-- Start Content-->
  <div class="container-fluid">

    <!-- casino1 -->
    <div class="row" *ngIf="events.casino1.includes(id)">

      <div class="col-md-12 px-1 d-none" *ngIf="!router.url.includes('casino')">
        <div class="sub_path">
          <p>Casino</p>
        </div>
      </div> <!-- end col-->

      <div class="col-md-12 px-1 d-none" *ngIf="router.url.includes('casino')">
        <div class="sub_path">
          <p>Casino</p>
        </div>
      </div> <!-- end col-->

      <div class="col-md-12 px-1" *ngIf="router.url.includes('casino')" style="margin-bottom: 2px;">
        <img class="d-block w-100" src="https://speedcdn.io/assets/radheexch-client/royalcasino-banner.jpg" alt="">
      </div> <!-- end col-->

      <div class="col-md-12 px-2">
        <div class="casino_section">
          <div class="row">
            <div class="col-md-2 col-4" (click)="confirmLogin(item)"
              *ngFor="let item of data?.event_types;trackBy:trackByIndex;">
              <img class="img-fluid" [lazyLoad]="getImagePath(item)">
              <h2>{{item?.name}}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- royal Casino -->
    <div class="row" *ngIf="events.royalCasino.includes(id)">

      <div class="col-md-12 px-1 d-none" *ngIf="!router.url.includes('casino')">
        <div class="sub_path">
          <p> Royal Casino</p>
        </div>
      </div> <!-- end col-->

      <div class="col-md-12 px-1 d-none" *ngIf="router.url.includes('casino')">
        <div class="sub_path">
          <p>Royal Casino</p>
        </div>
      </div> <!-- end col-->

      <div class="col-md-12 px-1" *ngIf="router.url.includes('casino')" style="margin-bottom: 2px;">
        <img class="d-block w-100" src="https://speedcdn.io/assets/radheexch-client/royalcasino-banner.jpg" alt="">
      </div> <!-- end col-->

      <div class="col-md-12 px-2">
        <div class="casino_section">
          <div class="row">
            <div class="col-md-2 col-4" (click)="confirmRoyalLogin(item)"
              *ngFor="let item of royalCasino;trackBy:trackByIndex;">
              <img class="img-fluid" [lazyLoad]="getImagePathRoyalCasino(item)">
              <h2>{{item?.name}}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- i-casino -->
    <div class="row" *ngIf="events.iCasino.includes(id)">
      
      <div class="col-md-12 px-1 d-none" *ngIf="!router.url.includes('casino')">
        <div class="sub_path">
          <p>I casino</p>
        </div>
      </div> <!-- end col-->

      <div class="col-md-12 px-1 d-none" *ngIf="router.url.includes('casino')">
        <div class="sub_path">
          <p>I casino</p>
        </div>
        <img class="d-block w-100" src="https://speedcdn.io/assets/radheexch-client/royalcasino-banner.jpg" alt="">
      </div> <!-- end col-->

      <div class="col-md-12 px-1">
        <div class="casinoTabs">
          <tabset type="tabs" #parentTabs>
            <tab *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent1(i)">
              <ng-template tabHeading>
                <span id="parentTab-{{i}}">
                  <!-- {{tabDt?.name | uppercase}} -->
                  <!-- <img class="img-fluid" src="assets/img/icasino-provider/{{tabDt?.slug | lowercase}}.png"> -->
                  {{tabDt?.name.charAt(0).toUpperCase() + tabDt?.name.slice(1)}}
                </span>
              </ng-template>
              <div class="row mx-0">
                <!-- sub csaino -->
                <div class="col-md-12 px-0">
                  <div class="is_navTabs engmenusub">
                    <tabset type="tabs" #childTabs>
                      <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelectChild1(j)">
                        <ng-template tabHeading>
                          <span id="childTab-{{i}}-{{j}}">
                            <img class="img-fluid tab-image" src="https://speedcdn.io/assets/int_tab_icons/{{innerTabDt?.slug}}.png">
                            <!-- {{innerTabDt?.name | uppercase}} -->
                            {{innerTabDt?.name.charAt(0).toUpperCase() + innerTabDt?.name.slice(1)}}
                          </span>
                        </ng-template>
                        <div class="row mx-0">
                          <!-- game start -->
                          <div class="col-md-12 px-0">
                            <!-- casino thumbnail -->
                            <div class="col-md-12 px-1">
                              <div class="casino_section">
                                <div class="row" *ngIf="cTabId == j">
                                  <div class="col-4 col-sm-3 col-md-3 col-lg-2 col-xl-2"
                                    (click)="confirmBox(item, tabDt.name)"
                                    *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                    <img class="img-fluid" [lazyLoad]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </tab>
                    </tabset>
                  </div>
                </div>
              </div>
            </tab>
          </tabset>
        </div>
      </div>
    </div>
  </div> <!-- container -->
</div> <!-- content -->